import React from 'react';

import { CompetitiveIntelligenceProvider } from './CompetitiveIntelligenceProvider';
import Ads from '../../../sections/overview/dashboards/views/competitiveIntelligence/ads';
import Overview from '../../../sections/overview/dashboards/views/competitiveIntelligence/overview';
import SearchTermsAnalysis from '../../../sections/overview/dashboards/views/competitiveIntelligence/search-term-analysis';
import CompetitionEvolution from '../../../sections/overview/dashboards/views/competitiveIntelligence/competition-evolution';

export const AdsWithProvider: React.FC = () => (
    <CompetitiveIntelligenceProvider>
        <Ads />
    </CompetitiveIntelligenceProvider>
);

export const OverviewWithProvider: React.FC = () => (
    <CompetitiveIntelligenceProvider>
        <Overview />
    </CompetitiveIntelligenceProvider>
);

export const SearchTermsAnalysisWithProvider: React.FC = () => (
    <CompetitiveIntelligenceProvider>
        <SearchTermsAnalysis />
    </CompetitiveIntelligenceProvider>
);

export const CompetitionEvolutionWithProvider: React.FC = () => (
    <CompetitiveIntelligenceProvider>
        <CompetitionEvolution />
    </CompetitiveIntelligenceProvider>
);

export const CompetitiveIntelligenceWithProvider = AdsWithProvider;


